import { MainMenuItem } from "@/utils/MenuItems.constants";
import EgwIcons from "../../../assets/EgwWebFont";
import { BreadcrumbType } from "@/shared/utils/breadcrumbs/constants";
import {
  makeBreadcrumbChapter,
  makeBreadcrumbLandingBook,
  makeBreadcrumbsChapter,
  makeBreadcrumbsObject,
  makeBreadcrumbsReader,
} from "@/shared/utils/breadcrumbs/breadcrumbs";
import { filterByLangAndSortBookTitles } from "@/utils/landing/landing.utils";

export const ReaderQueryParam = {
  panelSecond: "linkPanel",
  panelFirst: "id",
  indexPanelActive: "index",
};
export const CN_EL_READER_MODE = "note_reader-mode";
export const CN_EL_ARROW_PLAYER = "arrow-player";
export const CN_EL_SWIPE_ARROWS = "swipe-arrows";
export const getParamByActivePanel = (indexPanelActive) =>
  indexPanelActive === 0 ? ReaderQueryParam.panelFirst : ReaderQueryParam.panelSecond;

export const layoutIds = {
  l1: "l1",

  l2v: "l2v",
  l2h: "l2h",
};

export const layoutIcons = {
  [layoutIds.l1]: EgwIcons.stop,
  [layoutIds.l2v]: EgwIcons.L2v,
  [layoutIds.l2h]: EgwIcons.L2h,
};

export const panelLoading = {
  isAvailable: true,
  breadcrumbsProps: {
    title: "loading",
    breadcrumbs: [{ ...MainMenuItem, children: null }],
  },
};

export const panelOffline = {
  isAvailable: true,
  breadcrumbsProps: {
    title: "offline",
    breadcrumbs: [{ ...MainMenuItem, children: null }],
  },
};

export const makeBreadcrumbsChildrenLanding = (
  book,
  landingConfigBooksSet,
  bookTitles,
  bookSites,
  bookCategory,
  isSetLanding,
  isLanding,
) => {
  if (isSetLanding) {
    const isBookFromSet = bookTitles?.some((b) => b.id === book.id);
    if (isBookFromSet) {
      const bookSet = filterByLangAndSortBookTitles(bookTitles, landingConfigBooksSet, book.lang);
      const bookSetChapters = bookSet.map((book) => ({ ...book, id: book.first_para }));

      // Add kjv book to asi(RPRAC)
      if (landingConfigBooksSet.titleShort === "RPRAC") {
        bookSetChapters.push({ id: "1965.1", title: "King James Version" });
      }

      return bookSetChapters.map(makeBreadcrumbChapter);
    }

    return null;
  }

  if (isLanding) {
    const isBookFromSet = bookCategory?.books?.some((b) => b.id === book.id);
    if (isBookFromSet) {
      const bookSet = filterByLangAndSortBookTitles(
        bookCategory.books,
        landingConfigBooksSet,
        book.lang,
      );
      const bookSetChapters = bookSet.map((book) => {
        let urlLandingSuitable = "";
        const bookEn = Object.values(bookSites.allBooks).find(
          (bookSite) => bookSite.id === book.idEn,
        );

        if (bookEn?.urlLanding) {
          urlLandingSuitable = bookEn.urlLanding.substring(0, bookEn.urlLanding.lastIndexOf("/"));
          urlLandingSuitable = `${urlLandingSuitable}/${book.lang}`;
        }

        return { ...book, urlLanding: urlLandingSuitable };
      });
      return bookSetChapters.map(makeBreadcrumbLandingBook);
    }
  }

  return null;
};

// Temporary fix. Need to fetch book folders to know the full breadcrumbs in runtime.
export const makeBreadcrumbsPropsWithOldBreadcrumbs = (
  breadcrumbsOld,
  langs,
  book,
  toc,
  chapter,
  chapterId,
  isLanding,
  bookTitles,
  childrenCustomSuitableLang,
) => {
  const indexBook = breadcrumbsOld.breadcrumbs.findIndex((i) => i.type === BreadcrumbType.book);

  if (indexBook === -1) {
    return makeBreadcrumbsReader(
      isLanding,
      langs,
      null,
      book,
      toc,
      chapterId,
      MainMenuItem,
      bookTitles,
      childrenCustomSuitableLang,
    );
  }

  const breadcrumbs = breadcrumbsOld.breadcrumbs.slice(0, indexBook + 1);
  if (toc && toc.length && chapterId) {
    breadcrumbs.push(...makeBreadcrumbsChapter(toc, chapterId));
  }

  return {
    ...breadcrumbsOld,
    ...makeBreadcrumbsObject(breadcrumbs, breadcrumbsOld.realType),
  };
};

export const handlePanelBecameLoading = (panelData, panelId, panelDataPrev) => {
  const panelDataNew = {
    ...panelData,
    isLoading: true,
    currentPara: panelId,
  };

  if (panelData.paraListLoading || panelDataPrev?.paraList) {
    panelDataNew.paraListLoading = panelData.paraListLoading || panelDataPrev.paraList;
    panelDataNew.paraList = undefined;
  }

  return panelDataNew;
};

export const handlePanelBecameNotLoading = (panelCurr, panelId) => {
  const panelDataNew = {
    ...panelCurr,
    isLoading: false,
    currentPara: panelId,
  };

  if (panelDataNew.paraListLoading) {
    panelDataNew.paraListLoading = undefined;
  }

  return panelDataNew;
};

export const getChapterParasFromChaptersParasByParaId = (bookChaptersParas, paraId) => {
  let chapter = null;
  for (const chapterNumber in bookChaptersParas) {
    if (bookChaptersParas[chapterNumber]?.paras?.some((p) => p.para_id === paraId)) {
      chapter = bookChaptersParas[chapterNumber].paras;
    }
  }
  return chapter;
};

export const isSearchHighlightOK = (searchParamsQuery, searchTotal, paraData) => {
  if (!paraData) {
    return false;
  }

  return (
    (!searchParamsQuery && !paraData.highlight) ||
    (!searchTotal && !paraData.highlight) ||
    paraData.highlight === searchParamsQuery
  );
};

export const PanelIdOffline = "offline";
